<script>
/**
 * @emits {@click} purchase
 * @emits {@click} upgrade
 */
import { mapGetters, mapState } from 'vuex';
import HelperTimeConvert from '../Helper/TimeConvert.vue';

export default {
  components: { HelperTimeConvert },
  computed: {
    ...mapState(['state', 'iframeUrl']),
    ...mapGetters(['stateData']),
  },
};
</script>

<template>
  <div class="text-gamma text-12px text-right font-semibold leading-normal flex flex-row items-baseline justify-end pr-16px pt-4px">
    <HelperTimeConvert />

    <span class="px-12px">&bull;</span>

    <template v-if="stateData.actions.includes('upgrade')">
      <a
        v-if="iframeUrl"
        :href="iframeUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="text-12px text-gamma hover:text-alpha focus:text-alpha font-semibold transition-colors duration-150 ease-in-out border-t-0 border-l-0 border-r-0 border-b-2 border-transparent hover:border-orange-dark focus:border-orange-dark focus:outline-none"
        :title="$t('upc.opensNewHttpsWindow.upgrade')"
      >
        <h5>Unraid OS <em><strong>{{ stateData.humanReadable }}</strong></em></h5>
      </a>
      <button
        v-else
        @click="$emit('upgrade')"
        class="text-12px text-gamma hover:text-alpha focus:text-alpha font-semibold transition-colors duration-150 ease-in-out border-t-0 border-l-0 border-r-0 border-b-2 border-transparent hover:border-orange-dark focus:border-orange-dark focus:outline-none"
        :title="$t('upc.opensNewHttpsWindow.upgrade')"
      >
        <h5>Unraid OS <em><strong>{{ stateData.humanReadable }}</strong></em></h5>
      </button>
    </template>
    <h5 v-else>
      Unraid OS <em :class="{ 'text-red': stateData.error || state === 'EEXPIRED' }"><strong>{{ stateData.humanReadable }}</strong></em>
    </h5>

    <template v-if="stateData.actions.includes('purchase')">
      <a
        v-if="iframeUrl"
        :href="iframeUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="text-12px text-orange-dark font-semibold hover:text-alpha focus:text-alpha ml-12px transition-colors duration-150 ease-in-out border-t-0 border-l-0 border-r-0 border-b-2 border-transparent hover:border-orange-dark focus:border-orange-dark focus:outline-none"
        :title="$t('upc.opensNewHttpsWindow.purchase')"
      >{{ $t('actions.purchase') }}</a>
      <button
        v-else
        @click="$emit('purchase')"
        class="text-12px text-orange-dark font-semibold hover:text-alpha focus:text-alpha ml-12px transition-colors duration-150 ease-in-out border-t-0 border-l-0 border-r-0 border-b-2 border-transparent hover:border-orange-dark focus:border-orange-dark focus:outline-none"
        :title="$t('upc.opensNewHttpsWindow.purchase')"
      >{{ $t('actions.purchase') }}</button>
    </template>
  </div>
</template>
